export default "__VITE_ASSET__CWw$dGlG__"